<template>
  <div>
    <a-table :scroll="{ x: 1300 }" :pagination="false" :columns="columns" size="middle" :data-source="dataSource" row-key="id">
      <template slot="customTitle" slot-scope="text, record">
        <a class="custom-link" :href="link(record)" target="_blank">{{ record.title }}</a>
      </template>
      <template slot="customStatus" slot-scope="text, record">
        <div v-if="documentStatus[record.status]">
          <a-tag :color="documentStatus[record.status].color">{{ documentStatus[record.status].label }}</a-tag>
        </div>
        <span v-else>{{ record.status }}</span>
      </template>
      <template slot="creator" slot-scope="text, record">
        <span>{{ getUserName(record.creator) }}</span>
      </template>

      <template slot="action" slot-scope="text, record">
        <a @click="onRemove(record)">移除</a>
      </template>
    </a-table>
  </div>
</template>

<script>
import { documentStatus } from '@/utils/dictionary';

const columns = [
  {
    width: 80,
    title: 'ID',
    customRender: (_, record) => 'MR-' + record.id
  },
  {
    width: 300,
    ellipsis: true,
    title: '标题',
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    width: 120,
    ellipsis: true,
    key: 'status',
    title: '状态',
    scopedSlots: { customRender: 'customStatus' }
  },
  {
    width: 100,
    title: '创建人',
    key: 'creator',
    scopedSlots: { customRender: 'creator' }
    // customRender: (_, record) => record.relatedPerson.nickname || '--'
  },
  {
    width: 165,
    title: '创建时间',
    key: 'createdTime',
    dataIndex: 'createdTime'
  },
  {
    width: 165,
    title: '关联时间',
    key: 'relatedTime',
    dataIndex: 'relatedTime'
  },
  {
    width: 165,
    title: '更新时间',
    key: 'updatedTime',
    dataIndex: 'updatedTime'
  }
  // {
  //   width: 60,
  //   title: '操作',
  //   scopedSlots: { customRender: 'action' }
  // }
];

export default {
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    userData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      columns,
      loading: false,
      documentStatus
    };
  },
  computed: {
    link() {
      return record => {
        return this.$router.resolve({
          name: 'page:business:document:detail',
          params: { id: record.id }
        }).href;
      };
    }
  },
  methods: {
    getUserName(userId) {
      const user = this.userData.find(item => item.id === userId);
      if (user) {
        return user.nickname || '--';
      } else {
        return '--';
      }
    },
    onRemove(record) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要解除与该业务需求的关联关系吗?',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          console.log(record.id, self.loading);
        }
      });
    }
  }
};
</script>
